<router-outlet></router-outlet>
<app-global-loader></app-global-loader>
